import { render } from "./ModuUsua.vue?vue&type=template&id=e97060a8&scoped=true"
import script from "./ModuUsua.vue?vue&type=script&lang=js"
export * from "./ModuUsua.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=e97060a8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97060a8"]])

export default __exports__